module.exports = __webpack_public_path__ + "static/media/ftp.d433524c.svg";